import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from 'react'
import { AlertCircle, CheckCircle2, LoaderCircle } from 'lucide-react'

export function Button({ className = '', variant = 'primary', loading, loadingLabel = 'Memproses...', children, ...props }: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger'
  loading?: boolean
  loadingLabel?: string
}) {
  return (
    <button className={`button button--${variant} ${className}`} disabled={loading || props.disabled} {...props}>
      {loading ? <LoaderCircle size={17} className="spin" aria-hidden="true" /> : null}
      {loading ? loadingLabel : children}
    </button>
  )
}

export function EmptyState({ icon, title, description, action }: { icon: ReactNode; title: string; description: string; action?: ReactNode }) {
  return <div className="empty-state"><div className="empty-state__icon">{icon}</div><h3>{title}</h3><p>{description}</p>{action}</div>
}

export function Notice({ tone = 'info', children, ...props }: HTMLAttributes<HTMLDivElement> & { tone?: 'info' | 'success' | 'danger' }) {
  return <div className={`notice notice--${tone}`} role={tone === 'danger' ? 'alert' : 'status'} {...props}>
    {tone === 'success' ? <CheckCircle2 size={18} /> : <AlertCircle size={18} />}{children}</div>
}

export function Skeleton({ className = '' }: { className?: string }) {
  return <div className={`skeleton ${className}`} aria-hidden="true" />
}
